import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Tabs } from 'antd'
import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
  useHistory,
} from 'react-router-dom'
import { Http } from '../../../helpers/axois'
import { AppState } from '../../../stateManager/store'
import { appMapper } from './helpers'
import { AppContainer } from './AppContainer'
import { App } from './App'
import { EditApp } from './EditApp'
import { CreateApp } from './CreateApp'
import { IApp } from './type'
import style from './styles/marketplace-apps.module.css'
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus_btn.svg'
import './styles/utils.css'
import './styles/overrides.css'
import NoData from '../../apps/NoData'
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'

// icons
const { TabPane } = Tabs

const AppList = () => {
  const [loading, setLoading] = useState(true)
  const [apps, setApps] = useState<IApp[]>([])
  const history = useHistory()
  const orgId = useSelector((state: AppState) => state.org.selectedOrg?.id)
  const userId = useSelector((state: AppState) => state.user.data.user.id)
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  var canViewApps = (orgPermissions.includes('marketplace.PublishApp') || !orgPermissions.includes('org.View')) ||  loggedInUserId==selectedOrg?.owner;
  
  const getApps = useCallback(async () => {
    if(!canViewApps){
      return
    }
    const endpoint = `orgs/${orgId}/marketplaceApps`
    try {
      const { data: apps } = await Http.get(endpoint).toPromise()
      setApps(apps.map(appMapper))
    } catch (err) {
      if (err === "Forbidden") {
        canViewApps = false
      }
      console.error('failed to get marketplace apps: ', err)
    } finally {
      setLoading(false)
    }
  }, [orgId])

  const removeApp = (id: string) => {
    setApps((apps) => apps.filter((app) => app.id !== id))
  }

  // installed, uninstall
  const updateApp = (id: string, data: any) => {
    setApps((apps) =>
      apps.map((app) => (app.id === id ? { ...app, ...data } : app))
    )
  }

  useEffect(() => {
    getApps()
  }, [getApps])

  return (
    <div className={style.appList}>
      {canViewApps ? <>
      <Tabs defaultActiveKey="allApps" className="mp-apps-tab">
        <TabPane tab="All Apps" key="allApps">
          <AppContainer
            apps={apps}
            removeApp={removeApp}
            loading={loading}
            updateApp={updateApp}
          />
        </TabPane>
        <TabPane tab="My Apps" key="myApps">
          <AppContainer
            removeApp={removeApp}
            updateApp={updateApp}
            loading={loading}
            apps={apps.filter(el => el.createdBy.id === userId)}
          />
        </TabPane>
      </Tabs>

      {!loading && (
        <div
          className={style.plusIcon}
          onClick={() => history.push('/marketplace/apps/create')}
        >
          <PlusIcon width={24} height={24} onClick={() => {}} />
        </div>
      )}
      </> : <NoData
        svg={WarningIcon}
        header='Not Authorized'
        content='Please request owner of this organization to provide access'
        noButton={true}
      />}
    </div>
  )
}

export default function Apps() {
  const match: {
    url: string
  } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}/create`}>
        <CreateApp />
      </Route>

      <Route path={`${match.url}/:appId/preview`}>
        <App />
      </Route>

      <Route path={`${match.url}/:appId/edit`}>
        <EditApp />
      </Route>

      <Route path={match.url}>
        <AppList />
      </Route>

      <Route component={() => <Redirect to="/404" />} />
    </Switch>
  )
}
